export default "__VITE_ASSET__CH3BY$az__"